import Cookies from 'js-cookie';

function PayController($scope, $rootScope, $timeout, $http, stripe, SiteWinnersSvc, CartSummarySvc, NextDrawSvc, DrawsSvc, BuyLinkSvc, $location, PlanSvc, $routeParams, PurchaseTicketSvc, CartSvc, CartRemoveSvc, RecieptSvc, ContactInfoSvc, SiteDetailsSvc, userAnswersSvc ) {
	"ngInject";

	$scope.Order_APIKey = Cookies.get('TLF_Auth_Token');

  $scope.ProcessingError = false;
  $scope.CustomFields = null
  $scope.CustomFields_Validation_Failed = false;
  $scope.AllFieldsError = false;
  $scope.NoItemsError = false;
  $scope.NoEnvelopeError = false;
  $scope.ConfirmedTerms = false;
  $scope.ConfirmedLocation = false;
  $scope.ExpiryYears = []
  $scope.BillingCheckError = false;
  $scope.States = []

  $scope.Countries = [
	  {
		  ISOCode: "CA", Name: "Canada", States: [
			  { Name: "New Brunswick", ISOCode: "NB" },
			  { Name: "Nova Scotia", ISOCode: "NS" },
			  { Name: "Prince Edwards Island", ISOCode: "PE" },
			  { Name: "Newfoundland", ISOCode: "NL" },
			  { Name: "Quebec", ISOCode: "QC" },
			  { Name: "Ontario", ISOCode: "ON" },
			  { Name: "Saskatchewan", ISOCode: "SK" },
			  { Name: "Manitoba", ISOCode: "MB" },
			  { Name: "Alberta", ISOCode: "AB" },
			  { Name: "British Columbia", ISOCode: "BC" },
			  { Name: "NorthWest Territories", ISOCode: "NT" },
			  { Name: "Yukon", ISOCode: "YT" },
			  { Name: "Nunavut", ISOCode: "NU" }
		  ]
	  },
	  {
		  ISOCode: "US", Name: "United States of America", States: [
			  { Name: "Alabama", ISOCode: "AL" },
			  { Name: "Alaska", ISOCode: "AK" },
			  { Name: "American Samoa", ISOCode: "AS" },
			  { Name: "Arizona", ISOCode: "AZ" },
			  { Name: "Arkansas", ISOCode: "AR" },
			  { Name: "California", ISOCode: "CA" },
			  { Name: "Colorado", ISOCode: "CO" },
			  { Name: "Connecticut", ISOCode: "CT" },
			  { Name: "Delaware", ISOCode: "DE" },
			  { Name: "District of Columbia", ISOCode: "DC" },
			  { Name: "Federated States of Micronesia", ISOCode: "FM" },
			  { Name: "Florida", ISOCode: "FL" },
			  { Name: "Georgia", ISOCode: "GA" },
			  { Name: "Guam", ISOCode: "GU" },
			  { Name: "Hawaii", ISOCode: "HI" },
			  { Name: "Idaho", ISOCode: "ID" },
			  { Name: "Illinois", ISOCode: "IL" },
			  { Name: "Indiana", ISOCode: "IN" },
			  { Name: "Iowa", ISOCode: "IA" },
			  { Name: "Kansas", ISOCode: "KS" },
			  { Name: "Kentucky", ISOCode: "KY" },
			  { Name: "Louisiana", ISOCode: "LA" },
			  { Name: "Maine", ISOCode: "ME" },
			  { Name: "Marshall Islands", ISOCode: "MH" },
			  { Name: "Maryland", ISOCode: "MD" },
			  { Name: "Massachusetts", ISOCode: "MA" },
			  { Name: "Michigan", ISOCode: "MI" },
			  { Name: "Minnesota", ISOCode: "MN" },
			  { Name: "Mississippi", ISOCode: "MS" },
			  { Name: "Missouri", ISOCode: "MO" },
			  { Name: "Montana", ISOCode: "MT" },
			  { Name: "Nebraska", ISOCode: "NE" },
			  { Name: "Nevada", ISOCode: "NV" },
			  { Name: "New Hampshire", ISOCode: "NH" },
			  { Name: "New Jersey", ISOCode: "NJ" },
			  { Name: "New Mexico", ISOCode: "NM" },
			  { Name: "New York", ISOCode: "NY" },
			  { Name: "North Carolina", ISOCode: "NC" },
			  { Name: "North Dakota", ISOCode: "ND" },
			  { Name: "Northern Mariana Islands", ISOCode: "MP" },
			  { Name: "Ohio", ISOCode: "OH" },
			  { Name: "Oklahoma", ISOCode: "OK" },
			  { Name: "Oregon", ISOCode: "OR" },
			  { Name: "Palau", ISOCode: "PW" },
			  { Name: "Pennsylvania", ISOCode: "PA" },
			  { Name: "Puerto Rico", ISOCode: "PR" },
			  { Name: "Rhode Island", ISOCode: "RI" },
			  { Name: "South Carolina", ISOCode: "SC" },
			  { Name: "South Dakota", ISOCode: "SD" },
			  { Name: "Tennessee", ISOCode: "TN" },
			  { Name: "Texas", ISOCode: "TX" },
			  { Name: "Utah", ISOCode: "UT" },
			  { Name: "Vermont", ISOCode: "VT" },
			  { Name: "Virgin Island", ISOCode: "VI" },
			  { Name: "Virginia", ISOCode: "VA" },
			  { Name: "Washington", ISOCode: "WA" },
			  { Name: "West Virginia", ISOCode: "WV" },
			  { Name: "Wisconsin", ISOCode: "WI" },
			  { Name: "Wyoming", ISOCode: "WY" }
		  ]
	  },
	  {
		  ISOCode: "AE", Name: "United Arab Emirates", States: [
			  { Name: "Abu Dhabi", ISOCode: "AZ" },
			  { Name: "Fujairah", ISOCode: "FU" },
			  { Name: "Sharjah", ISOCode: "SH" },
			  { Name: "Dubai", ISOCode: "DU" },
			  { Name: "Ras Al Khaimah", ISOCode: "RK" },
			  { Name: "Umm Al Quwain", ISOCode: "UQ" },
			  { Name: "Ajman", ISOCode: "AJ" }
		  ]
	  }
  ]


  //Page JS
  jQuery(document).ready(function ($) {
    $('input[type=text],input[type=email],input[type=password]').on('keyup', function () {
      checkInputLabels();
    });
    function checkInputLabels() {
      $('input[type=text],input[type=email],input[type=password]').each(function () {
        if ($(this).val() !== '') {
          $(this).next('label').addClass('active');
        } else {
          $(this).next('label').removeClass('active');
        }
      });
    }
    checkInputLabels();

    $('.detailed-trigger').on('click', function (e) {
      e.preventDefault();
      $('#detailed-modal').fadeIn(500);
    });

    $('#detailed-modal .close').on('click', function (e) {
      e.preventDefault();
      $('#detailed-modal').fadeOut(500);
    });

	//Expand Cart Items 
	$('body').on('click', "h4.toggler", function (e) {
        e.stopImmediatePropagation();
		var $table = $(this).siblings('.wrap');

		if ( $(this).hasClass('closed') ) {
		  $(this).removeClass('closed');
		  $table.slideDown(500);
		} else {
		  $(this).addClass('closed');
		  $table.slideUp(500);
		}
	  });

	$scope.CardHoldersName = '';
	$scope.CardHoldersNumber = '';
	$scope.CardHoldersExpiryMonth = '';
	$scope.CardHoldersExpiryYear = '';
	$scope.CardHoldersCVV = '';
	for (var i = 0; i < 10; i++) {
	  $scope.ExpiryYears.push({ val: parseInt(new Date().getFullYear().toString().substr(-2)) + i, text: parseInt(new Date().getFullYear().toString()) + i})
	}

    $http.get(TFL_Base_Url + 'site/userDefinedFields?Id=' + TFL_ID + '&Lang=English').then(function (data) {
      $scope.CustomFields = data.data
    });
    $http.get(TFL_Base_Url + 'site/userDefinedFieldsTitle?Id=' + TFL_ID + '&Lang=English').then(function (data) {
        $scope.CustomFieldTitle = data.data
        if ($scope.CustomFieldTitle == null || $scope.CustomFieldTitle == "") {
            $scope.CustomFieldTitle = "Other Information"
        }
    });
  });

	$scope.Contact_Validation_Failed = false;

	$scope.SaveContactInfo = function (FirstName, LastName, Address, Postal, City, Province, Country, Phone, callback) {

    $scope.CustomFields_Validation_Failed = false;
    $scope.Contact_Validation_Failed = false;

	if ($rootScope.SiteDetails.isRequiredBillingCity == false)
	{
		City = 'N/A';
	}

	if ($rootScope.SiteDetails.isRequiredBillingPostal == false)
	{
		Postal = 'N/A';
	}

	if ($rootScope.SiteDetails.isRequiredBillingProv == false)
	{
		Province = 'N/A';
	}

    if (FirstName == '' || LastName == '' || Address == '' || Postal == '' || City == '' || Province == '' || Country == '' || Phone == '' || FirstName == null || LastName == null || Address == null || Postal == null || City == null || Province == null || Country == null || Phone == null) {
      $scope.Contact_Validation_Failed = true;
    }

    $scope.CustomFields.forEach(function (field) {
      if (field.Selection == null && field.field.isRequired == true) {
        $scope.CustomFields_Validation_Failed = true;
      }
    })

    if ($scope.Contact_Validation_Failed || $scope.CustomFields_Validation_Failed)
    {
        $scope.AllFieldsError = true;
		callback(true);
    }
    else
    {
			$scope.Contact_Validation_Failed = false;
			callback(false);
      jQuery(document).ready(function ($) {
				ContactInfoSvc.put({ APIKey: Cookies.get('TLF_Auth_Token') }, {
					ContactFirstName: FirstName,
					ContactLastName: LastName,
					ContactAddress: Address,
					ContactPostalZip: Postal,
					ContactCity: City,
					ContactProvinceState: Province,
					ContactCountry: Country,
					ContactPhone: Phone
        }, function (data) {

        });
      });
    }

  }

	//Pay Now Click
  $scope.PayNow = function () {
	$scope.AllFieldsError = false;
	$scope.BillingCheckError = false;

	  if ($scope.SiteDetails.isBillingLocationRequired == true) {
		  $http.get(TFL_Base_Url + "purchase/checkBilling?APIKey=" + Cookies.get('TLF_Auth_Token')
			  + "&Country=" + $scope.User.ContactCountry + "&StateProvince=" + $scope.User.ContactProvinceState
			  + "&City=" + $scope.User.ContactCity).then(function (data) {
				  if (data.data == false) {
					  //don't allow purchase
					  $scope.BillingCheckError = true
				  }
				  else {
					  $scope.SaveContactInfo(
						  $scope.User.ContactFirstName,
						  $scope.User.ContactLastName,
						  $scope.User.ContactAddress,
						  $scope.User.ContactPostalZip,
						  $scope.User.ContactCity,
						  $scope.User.ContactProvinceState,
						  $scope.User.ContactCountry,
						  $scope.User.ContactPhone, function (ret) {
							  if (ret == false) {
								  $scope.PayWithCredit();
							  }
							  else {
								  $scope.CheckCreditCardFields();
							  }
						  }
					  );
                  }
			  });
	  }
	  else {
		  $scope.SaveContactInfo(
			  $scope.User.ContactFirstName,
			  $scope.User.ContactLastName,
			  $scope.User.ContactAddress,
			  $scope.User.ContactPostalZip,
			  $scope.User.ContactCity,
			  $scope.User.ContactProvinceState,
			  $scope.User.ContactCountry,
			  $scope.User.ContactPhone, function (ret) {
				  if (ret == false) {
					  $scope.PayWithCredit();
				  }
				  else {
					  $scope.CheckCreditCardFields();
				  }
			  }
		  );
	  }
  }


	//This is called on the click event of the pay by credit button.
	$rootScope.ResetPayByCreditModal = function () {

		$scope.ProcessingError = false;
		$scope.PayByCredit_Processing = false;
		//$scope.HidePayByCreditFields = false;

		$scope.CardHoldersNameError = false;
		$scope.CardHoldersNumberError = false;
		$scope.CardHoldersExpiryMonthError = false;
		$scope.CardHoldersExpiryYearError = false;
		$scope.CardHoldersCVVError = false;

		//$scope.CardHoldersName = '';
		//$scope.CardHoldersNumber = '';
		//$scope.CardHoldersExpiryMonth = '';
		//$scope.CardHoldersExpiryYear = '';
		//$scope.CardHoldersCVV = '';

		$scope.CreditCardFieldsExist = true;

	}

	$timeout(function () {
		$scope.HidePayByCreditFields = false;
	});


	$scope.PayByCredit_Processing = false;

	//PayWithCredit
	$scope.PayWithCredit = function () {

        $scope.CheckCreditCardFields();
        if ($scope.CreditCardFieldsExist && ($scope.ConfirmedTerms && (($scope.ConfirmedLocation && $rootScope.SiteDetails.showLocationConfirmation) || !$rootScope.SiteDetails.showLocationConfirmation))) {

			$scope.PayByCredit_Processing = true;
			$timeout(function () {
				$scope.Processing_PayPal = true;
			});

			//PurchaseByCreditSvc
			jQuery(document).ready(function ($) {

				$scope.ProcessingError = false;

				stripe.setPublishableKey($rootScope.SiteDetails.StripePublicAccessToken);

				$scope.payment = {};
				$scope.payment.card = {};
				$scope.payment.card.number = $scope.CardHoldersNumber;
				$scope.payment.card.exp_month = $scope.CardHoldersExpiryMonth;
				$scope.payment.card.exp_year = $scope.CardHoldersExpiryYear;
				$scope.payment.card.cvc = $scope.CardHoldersCVV;

				$scope.payment.card.name = $scope.User.ContactFirstName + " " + $scope.User.ContactLastName;
				$scope.payment.card.address_line1 = $scope.User.ContactAddress;
				$scope.payment.card.address_city = $scope.User.ContactCity;
				$scope.payment.card.address_state = $scope.User.ContactProvinceState;
				$scope.payment.card.address_zip = $scope.User.ContactPostalZip;
				$scope.payment.card.address_country = $scope.User.ContactCountry;

				$scope.charge = function charge() {
					return stripe.card.createToken($scope.payment.card)
				    .then(function (response) {
						// console.log('token created for card ending in ', response.card.last4);
						var payment = angular.copy($scope.payment);
						payment.card = undefined;
						payment.token = response.id;
						return $http.post(TFL_Base_Url + '/purchase/bystripeexpress?Amount=' + $rootScope.CartItems_Total + '&APIKey=' + Cookies.get('TLF_Auth_Token') + '&StripeToken=' + payment.token);
					})
					.then(function (payment) { //Payment Accepted
						if (payment.data.Status != "Approved") { //Not Approved
							throw new Error('Your credit card info is not valid.');
						}
						else //Approved
						{
							if ($scope.CustomFields.length > 0) { //Save Custom Fiels and Redirect to thank you page
								userAnswersSvc.post({ ApiKey: Cookies.get('TLF_Auth_Token'), CartTransactionId: payment.data.CartTransactionId }, JSON.stringify($scope.CustomFields), function (data) {
									$location.url($location.path('/thank-you/' + payment.data.CartTransactionId).replace());
									$location.path('/thank-you/' + payment.data.CartTransactionId).replace();
								});
							}
							else { //Redirect to thank you page
								$location.url($location.path('/thank-you/' + payment.data.CartTransactionId).replace());
								$location.path('/thank-you/' + payment.data.CartTransactionId).replace();
							}
						}
					})
					.catch(function (err) {
						if (err.type && /^Stripe/.test(err.type)) {
					     	// console.log('Stripe error: ', err.message);
                        } else {
                            // console.log('Other error occurred, possibly with your API', err.message);
                        }
						$timeout(function () {
							$scope.Processing_PayPal = false;
						});
						if (err.data != undefined) {
							if (err.data.Status == "No items remaining in shopping cart")
								$scope.NoItemsError = true;
							else if (err.data.Status == "No envelope") {
								$scope.NoEnvelopeError = true;
							}
							$scope.PayByCredit_Processing = false;
						}
                        else {
                            $scope.HidePayByCreditFields = true;
                            $rootScope.ResetPayByCreditModal();
                            $scope.ProcessingError = true;
                            $scope.CardHoldersNumberError = true;
                            $scope.CardHoldersNameError = true;
                            $scope.CardHoldersCVVError = true;
                            $scope.CardHoldersExpiryYearError = true;
                            $scope.CardHoldersExpiryMonthError = true;
                            $scope.AllFieldsError = true;
                        }
					})
				}
				$scope.charge();
        
			});
		}
		else {
			$scope.ErrorShake = true;
			$timeout(function () {
				$scope.ErrorShake = false;
			}, 1000);
		}

	}

	$scope.CreditCardFieldsExist = false;

	$scope.CheckCreditCardFields = function () {
		$scope.CreditCardFieldsExist = true;
		$scope.CheckCardHoldersName();
		$scope.CheckCardHoldersNumber();
		$scope.CheckCardHoldersExpiryMonth();
		$scope.CheckCardHoldersExpiryYear();
        $scope.CheckCardHoldersCVV();
	}

	$scope.CardHoldersName = '';
	$scope.CardHoldersNameError = false;
    $scope.CheckCardHoldersName = function () {
		if ($scope.CardHoldersName == '' || $scope.CardHoldersName.indexOf(" ") === -1) {
			$scope.CardHoldersNameError = true;
			$scope.CreditCardFieldsExist = false;
		}
		else {
			$scope.CardHoldersNameError = false;
		}
	}
	$scope.CardHoldersNumber = '';
	$scope.CardHoldersNumberError = false;
	$scope.CheckCardHoldersNumber = function () {
		if ($scope.CardHoldersNumber == '') {
			$scope.CardHoldersNumberError = true;
			$scope.CreditCardFieldsExist = false;
		}
		else {
			$scope.CardHoldersNumberError = false;
		}
	}

	//CardHoldersExpiryMonth
	$scope.CardHoldersExpiryMonth = '';
	$scope.CardHoldersExpiryMonthError = false;
	$scope.CheckCardHoldersExpiryMonth = function () {
		if ($scope.CardHoldersExpiryMonth == '') {
			$scope.CardHoldersExpiryMonthError = true;
			$scope.CreditCardFieldsExist = false;
		} else {
			$scope.CardHoldersExpiryMonthError = false;
		}
	}

	//CardHoldersExpiryYear
	$scope.CardHoldersExpiryYear = '';
	$scope.CardHoldersExpiryYearError = false;
	$scope.CheckCardHoldersExpiryYear = function () {
		if ($scope.CardHoldersExpiryYear == '') {
			$scope.CardHoldersExpiryYearError = true;
			$scope.CreditCardFieldsExist = false;
		} else {
			$scope.CardHoldersExpiryYearError = false;
		}

	}

	//CardHoldersCVV
	$scope.CardHoldersCVV = '';
	$scope.CardHoldersCVVError = false;
	$scope.CheckCardHoldersCVV = function () {
		if ($scope.CardHoldersCVV == '') {
			$scope.CardHoldersCVVError = true;
			$scope.CreditCardFieldsExist = false;
		}
		else {
			$scope.CardHoldersCVVError = false;
		}
	}



  $scope.FriendlyTicketNumber = $routeParams.FriendlyTicketNumber;

	//Clear Cart
  $scope.RemoveItems = function () {
      
      CartRemoveSvc.delete({ APIKey: Cookies.get('TLF_Auth_Token')}, function () {});

      $scope.CartItems = [];

      //New Cart Total
      $scope.CartTotal = 0;
      $rootScope.CartItems_Total = 0;

      //Removes it from the menu cart count.
      $rootScope.CartItems_Count = 0;

      $location.url($location.path('/').replace());
      $location.path('/').replace();
  }

	//Remove Ticket
  $scope.RemoveItem = function (i) {
      //Remove Item At The Server
      jQuery(document).ready(function ($) {
				CartRemoveSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), CartItemId: i.Id }, function () {
					CartSummarySvc.get({ APIKey: $scope.CookieValue }, function (data) {
						$scope.CartSummary = data;
					});
				});
      });

      //Remove From Local Array For Performance
      var index = $scope.CartItems.indexOf(i);
      $scope.CartItems.splice(index, 1);

      //Calculate Cart Total
      var total = 0;
      for (var i = 0; i < $scope.CartItems.length; i++) {
          var product = $scope.CartItems[i];
          total += (product.Amount);
      }

			if (total === 0)
			{
				$location.url($location.path('/purchase').replace());
				$location.path('/purchase').replace();
			}


	  total = Math.round(total, 2);

      //New Cart Total
      $scope.CartTotal = total;
      $rootScope.CartItems_Total = total;

      //Removes it from the menu cart count.
      $rootScope.CartItems_Count = $rootScope.CartItems_Count - 1;
  }

	//Loading Cart Variable
  $scope.LoadingCart = true;
	$scope.LoadingSeperateCartItems = true;

  //CartSvc
  $scope.CartItems = {};

  $scope.CookieValue = '';
  jQuery(document).ready(function ($) {
      $scope.CookieValue = Cookies.get('TLF_Auth_Token');
  });



	if ($scope.CookieValue !== undefined) {

			CartSummarySvc.get({ APIKey: $scope.CookieValue }, function (data) {
				$scope.CartSummary = data;
				$scope.LoadingCart = false;

				$scope.Countries.find(function (item, i) {
					if (item.ISOCode === $scope.User.ContactCountry) {
						$scope.States = $scope.Countries[i].States
					}
				});
			});


      CartSvc.get({ APIKey: $scope.CookieValue }, function (data) {
          var total = 0;
          for (var i = 0; i < data.length; i++) {
              var product = data[i];
			  total += product.Amount;
		  }

		  total = Math.round(total, 2);
		  
          $rootScope.CartItems_Count = data.length;
          $scope.CartTotal = total;
          $rootScope.CartItems_Total = total;
          $scope.CartItems = data;
					$scope.LoadingSeperateCartItems = false;
      });
  }



    $scope.CheckCanBuy = function () {
        //Terms and conditions checkbox has been checked
        var TermsAndConditionsConfirmed = $scope.ConfirmedTerms
        //Location confirmation is enabled and has been checked off on
        var LocationConfirmed = ($scope.ConfirmedLocation && $rootScope.SiteDetails.showLocationConfirmation)
        //Location confirmation enabled (false) or disabled (true)
        var LocationConfirmationDisabled = !$rootScope.SiteDetails.showLocationConfirmation

        //Terms and conditions confirmed AND location confimed or location disabled
        if (TermsAndConditionsConfirmed && (LocationConfirmed || LocationConfirmationDisabled))
            return false
        else
            return true
    }

  //Paypal start
  $scope.afterPurchase = false;

	//Paypal processing var
  $scope.Processing_PayPal = false;

	//PayPal Checkout
  $scope.paypalCheckout = function()
  {
      jQuery(document).ready(function ($) {
          if (Cookies.get('TLF_Auth_Token') !== undefined) {
              $scope.APIKey = Cookies.get('TLF_Auth_Token')

          }

          $timeout(function () {
              $scope.Processing_PayPal = true;
          });


          paypal.checkout.initXO();

          $.ajax({
              url: TFL_Base_Url + 'purchase/bypaypal/process',
              type: "GET",
              data: 'APIKey=' + $scope.APIKey,
              async: true,
              crossDomain: true,
              //Load the minibrowser with the redirection url in the success handler
              success: function (token) {
                  var url = paypal.checkout.urlPrefix + unescape(token);
                  //Loading Mini browser with redirect url, true for async AJAX calls
                  paypal.checkout.startFlow(url);
              },
              error: function (responseData, textStatus, errorThrown) {
                  alert("Error in ajax post" + responseData.statusText);
                  //Gracefully Close the minibrowser in case of AJAX errors
                  paypal.checkout.closeFlow();
              }
          });
      });
  }

	$scope.UpdateBillingStates = function () {
		$scope.Countries.find(function (item, i) {
			if (item.ISOCode === $scope.User.ContactCountry) {
				$scope.States = $scope.Countries[i].States
			}
		});
    }

};


export default {
  name: 'payController',
  fn: PayController
}